import React, {ReactElement} from 'react';
import {Main} from "./Main";
import {PathComponent} from "../index";
import {AppPrefListener} from "../shared/types";
import {BaseAppPrefs} from "../shared/BaseAppPrefs";
import {LoginConfig} from "../shared/Login";
import {AccountProfileContextTrait, Page} from "@/libwyze-shared/types";
import {AppPrefs} from "@/app-modules/checkin-manager/app_prefs";
import {ElementsApp, ElementsAppProps, ElementsAppState} from "@/elements-shared/ElementsApp";
import {ModuleName, MODULES} from "../app-modules/modules";
import {Smilebook} from "../smilebook-shared/types";

export type AppProps = ElementsAppProps & {}

type AppState = ElementsAppState & {}

export class App extends ElementsApp<AppProps, AppState> implements AccountProfileContextTrait, AppPrefListener {

  protected getLoginConfig(): LoginConfig | null | undefined {
    return {
      provisioning: {
        membersUseSharedProvisioningContext: true,
      },
      uiProps: {
        bottomDecorator: <img src={"/images/dentwyze_elements_logotype.svg"} style={{height: 48}}/>,
      },
    };
  }
  
  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  protected async onPracticePageLoaded(page: Page): Promise<void> {
    await super.onPracticePageLoaded(page);
    const pathParts = this.props.path.location.pathname.split("/").filter(Boolean);
    const selectedModule = MODULES.find(module => module.name === pathParts[0]) || MODULES[0];
    switch (selectedModule.name) {
      case ModuleName.SMILEBOOK_DESIGNER:
        await Smilebook.loadInstance(page.id);
        break;
    }
  }

  getAppPrefs<T extends BaseAppPrefs>(): T {
    //@ts-ignore
    return AppPrefs.getInstance() as T;
  }

  protected getAppName(): string {
    return "Elements"
  }

  protected renderElementsMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
